import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function getListFlowAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "process-builder/flow/list", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function createFlowAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "process-builder/flow/create", data, {
    headers: {
      Authorization: token,
    },
  });
}
export async function updateFlowAPI(data) {
  const token = await checkTokenExpiration();
  return axios.put(
    BASE_URL_API + `process-builder/flow/update/${data.process_id}`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
export async function deleteFlowAPI(data) {
  const token = await checkTokenExpiration();
  return axios.delete(
    BASE_URL_API + `process-builder/flow/remove/${data.process_id}`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function getListComponentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(
    BASE_URL_API + `process-builder/flow/${data.flow_id}/list-component`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function getListActionAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(BASE_URL_API + `process-builder/list-component`, {
    headers: {
      Authorization: token,
    },
  });
}

export async function removeComponentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `process-builder/flow/remove-component/${data.process_flow_id}`,
    data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
